import { useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'
import { chatLocalMutesAtom } from '../../../store/atoms'
import { getOffsetSeat } from '../../../utils'
import { BubbleWithArrow } from '../../molecules/BubbleWithArrow'
import { bubbleBySeat, bubbleStyle } from './index.css'

export const ChatOnTable = (props: {
  newMessage?: { userId: string; text: string }
  players: {
    userId: string
    seat: number
    avatar: string | null
  }[]
  offset?: number
  maxPlayers: number
  currentUserId: string | null
  displayDuration?: number
}) => {
  const displayDuration = props.displayDuration || 5_000

  const [bubbles, setBubbles] = useState<
    Record<string, { text: string; timerId: number }>
  >({})
  const chatLocalMutes = useAtomValue(chatLocalMutesAtom)

  useEffect(() => {
    const { newMessage } = props
    if (!newMessage || chatLocalMutes.has(newMessage.userId)) {
      return
    }

    setBubbles((prev) => {
      if (prev[newMessage.userId]) {
        clearTimeout(prev[newMessage.userId].timerId)
      }
      const timerId = window.setTimeout(() => {
        setBubbles((prevInTimeout) => {
          const copy = { ...prevInTimeout }
          delete copy[newMessage.userId]
          return copy
        })
      }, displayDuration)

      return {
        ...prev,
        [newMessage.userId]: {
          text: newMessage.text,
          timerId,
        },
      }
    })
  }, [props.newMessage, displayDuration])

  const getArrowPosition = (
    seat: number,
  ): {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'middle' | 'right'
  } => {
    if ([2].includes(seat)) return { vertical: 'top', horizontal: 'middle' }
    if ([1, 0, 8, 7].includes(seat))
      return { vertical: 'bottom', horizontal: 'left' }
    if ([3, 4, 5, 6].includes(seat))
      return { vertical: 'bottom', horizontal: 'right' }
    throw new Error(`There is unhandled seat: ${seat}.`)
  }

  return (
    <>
      {Object.entries(bubbles).map(([userId, bubble]) => {
        if (userId === props.currentUserId) {
          return null
        }
        const player = props.players.find((p) => p.userId === userId)
        if (!player) {
          return null
        }

        const seat = getOffsetSeat(player.seat, props.offset, props.maxPlayers)
        const arrowPosition = getArrowPosition(seat)

        return (
          <div
            key={userId}
            className={bubbleBySeat[seat]}
          >
            <BubbleWithArrow
              arrowPosition={arrowPosition}
              className={bubbleStyle}
              variant={'other'}
            >
              {bubble.text}
            </BubbleWithArrow>
          </div>
        )
      })}
    </>
  )
}
